import grains from '../../Assets/layout_images/grains.png'

export default function StateCbseGrains() {
    return (
        <div className="grains_state">
            {/* <img src={grains} alt="grains" /> */}
        </div>
    )
}
